// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"938c845b","689":"a7a62f30","776":"afd789a7","818":"3232e1c2","904":"9d30fd60"}[chunkId] + ".chunk.css";
};